class CollectionPagination extends HTMLElement {
  

    constructor() {

        super();

        this.loadBtn = this.querySelector('button');   
        this.paginationData = this.querySelector('.pagination-data');
        this.nextPage = this.paginationData.dataset.next;  
        this.loadBtn.addEventListener('click', this.onClickHandler.bind(this));    
        this.triggerCounter = 0;  

        this.helper = this.querySelector('#helper');
        this.helperInner = this.helper.querySelector('.helper-inner');
        this.loader = this.helper.querySelector('.loader');
        this.status = this.helper.querySelector('[role="status"]');
        this.description = this.querySelector('.collection-description');

        if(this.nextPage != 'null' && this.nextPage != '') {       
            this.observerOptions = { rootMargin: "0px 0px 250px 0px" };
            let observer = new IntersectionObserver(this.obsCallback.bind(this), this.observerOptions);     
            observer.observe(this);  
        } else { observer.disconnect(); }
       
    }
  

    reassignAtrs() {
        this.paginationData = this.querySelector('.pagination-data');
        this.nextPage = this.paginationData.dataset.next; 
        if(this.nextPage == 'null' || this.nextPage == ''){
            this.loadBtn.remove();
            this.toggleHelper('complete');
        } else { this.toggleHelper('off') }
    }
     

    obsCallback(entries, observer) {
        entries.forEach(entry => {
            if(entry.isIntersecting) {
                this.triggerCounter++;
                this.triggerCounter <= 2 ? this.onClickHandler() : this.manageButton(observer);
            }
        });

    }


    manageButton(observer) {
        this.loadBtn.classList.add('on');
        this.description.classList.add('on');
        observer.disconnect();
    }
     

    onClickHandler() {
        this.toggleHelper('on');
        if(this.nextPage != 'null' && this.nextPage != ''){ 
            (async () => {
                let getNext = await this.getPageContent(this.nextPage);             
                if(getNext[1].status == 200) {
                    this.handleContent_success(getNext)                   
                }
            })();
        } else { this.toggleHelper('complete') }   
    }


    handleContent_success(getNext) {
        this.appendItems(getNext[0].querySelectorAll('li.js_grid-item'));
        this.paginationData.remove();
        let newPaginationData = getNext[0].querySelector('.pagination-data');
        this.append(newPaginationData);   
        this.reassignAtrs();       
    }


    toggleHelper(state) {

        this.helperInner.classList.remove('on');
        this.loader.classList.remove('on', 'stay');
        this.status.classList.remove('on');

        if(state == 'on') {
            //console.log('on');
            this.helperInner.classList.add('on');
            setTimeout(() => {
                this.loader.classList.add('on');
                this.status.classList.add('on');
            },100)     		
			this.status.innerHTML = `<span>Loading...</span>`;
        }

        if(state == 'off') {
            //console.log('off');
            this.helperInner.classList.remove('on');
            this.loader.classList.remove('on');
            this.status.classList.remove('on');
        }

        if(state == 'complete') {
            //console.log('complete')
            this.helperInner.classList.add('on');         
            setTimeout(() => {
                this.loader.classList.add('stay');
                this.status.classList.add('on');
            },100)
            this.status.innerHTML = `<span>No more products</span>`;
           
        }

    }
   

    async getPageContent(url) { 
        try {    
            const response = await fetch(url); 
            if (!response.ok) {
                throw new Error(`HTTP error, Status: ${response.status}`);
            } else {
                const html = await response.text();
                //console.log(html)
                const parsedHTML = new DOMParser().parseFromString(html, 'text/html'); 
                //console.log('Request completed successfully!');  
              
                return [parsedHTML, response];  
            }
        } catch (error) {
            console.log('Error:', error.message);
            throw error;
        }    
    }
     

    /* 
    This version of appendItems() will take the fetched items,
    create a new ul element, append the items to it, and then
    insert the new ul element before the pagination-container.
    This ensures that any items beyond page 1 keep the original grid layout
    */

    appendItems(items) {  
        const temp_ul = document.createElement('ul');
        temp_ul.classList.add('appended-ul');
        var appendTo = document.querySelector('#pagination-container')
        items.forEach((item) => { 
            item.classList.add('appended-item');
            temp_ul.append(item);         
        })
        appendTo.parentNode.insertBefore(temp_ul, appendTo);
        if(window) {
            window.scrollAnimations.refresh();
        }
    }


    // appendItems(items) {  
    //     var duration = 100; 
    //     var appendTo = document.querySelector('#product-grid[data-id]');
    //     items.forEach((item) => { 
    //         duration += 100;
    //         item.classList.add('appended-item');
    //         setTimeout(() => { appendTo.append(item) }, duration)
            
    //     })
    // }
    
  }
  customElements.define('collection-pagination', CollectionPagination)




